import { BoxProps } from "@chakra-ui/react";

function CircularEnDark({ ...props }: BoxProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#BEBEC6"/>
    <path d="M4.4375 13.6688V6.3291H8.6631V7.11014H5.36873V9.41319H8.14241V10.2042H5.36873V12.8878H8.77325V13.6688H4.4375Z" fill="#BEBEC6"/>
    <path d="M10.334 13.6688V6.3291H11.2853L13.9588 10.9552L14.7498 12.4773H14.7999C14.7398 11.7363 14.6697 10.9052 14.6697 10.1442V6.3291H15.5609V13.6688H14.5996L11.9361 9.0427L11.1451 7.53069H11.095C11.1451 8.27168 11.2152 9.0427 11.2152 9.82374V13.6688H10.334Z" fill="#BEBEC6"/>
    </svg>
  );
}

export { CircularEnDark };

